import RedirectPage from "./RedirectPage";

export default RedirectPage;
